import script from "./VoteScore.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VoteScore.vue?vue&type=script&lang=js"
export * from "./VoteScore.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./VoteScore.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-components/base-story-card/VoteScore.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35fa5260"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35fa5260', __exports__)) {
    api.reload('35fa5260', __exports__)
  }
  
}


export default __exports__